export default {"src":"/catalog/_next/static/media/Close.408d739c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};